import { render, staticRenderFns } from "./ActivityDuration.vue?vue&type=template&id=6d243a8b&scoped=true&"
import script from "./ActivityDuration.vue?vue&type=script&lang=js&"
export * from "./ActivityDuration.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDuration.vue?vue&type=style&index=0&id=6d243a8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d243a8b",
  null
  
)

export default component.exports